import useSWRMutation from "swr/mutation";

interface ActivateAccountProps {
  arg: {
    token: string;
    password: string;
    username?: string;
  };
}

const activateAccount = async (_: string, { arg }: ActivateAccountProps) => {
  const AUTH_URL = process.env.NEXT_PUBLIC_BACKEND_AUTH_URL || "";
  const BACKEND_URL = process.env.NEXT_PUBLIC_BACKEND_URL || "";
  const { token, password, username } = arg;

  const rawResponse = await fetch(`${AUTH_URL ?? BACKEND_URL}/activate`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      token,
      password,
      username,
    }),
  });

  const response = await rawResponse.json();

  if (response.code >= 400) {
    throw new Error(response.message);
  }

  return {
    code: response.code,
    message: response.message,
    token: response?.token,
    user: response?.user,
  };
};

export const useActivateAccount = (): ReturnType<
  typeof useSWRMutation<
    Awaited<ReturnType<typeof activateAccount>>,
    Error,
    string,
    ActivateAccountProps["arg"]
  >
> => {
  return useSWRMutation("useActivateAccount", (_, arg) => activateAccount(_, arg));
};
